"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var getLocalHashData = function (url) {
    if (utils_1.isLocalStorageAvailable()) {
        var hash = utils_1.createHashFromString(url);
        var data = localStorage.getItem(hash);
        if (data)
            return JSON.parse(data);
        return null;
    }
    return null;
};
exports.getLocalHashData = getLocalHashData;
var updateLocalHashData = function (url, data) {
    if (utils_1.isLocalStorageAvailable()) {
        var hash = utils_1.createHashFromString(url);
        return localStorage.setItem(hash, JSON.stringify(data));
    }
    return false;
};
exports.updateLocalHashData = updateLocalHashData;
